"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var table_row_1 = require("../../model/table-row");
var form_resolution_service_1 = require("../../../../shared/services/api/form-resolution.service");
var base_table_component_1 = require("../base-table/base-table.component");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var HierarchicalTableComponent = /** @class */ (function (_super) {
    __extends(HierarchicalTableComponent, _super);
    function HierarchicalTableComponent(classifierService, kbService, formResolutionService) {
        var _this = _super.call(this, kbService, formResolutionService) || this;
        _this.classifierService = classifierService;
        _this.isReady = false;
        _this.hasData = false;
        _this.tableData = [];
        _this.columnData = [];
        return _this;
    }
    HierarchicalTableComponent.prototype.ngOnChanges = function (changes) {
        if (!this.isPopupOpened && this.columnData.length) {
            this.updateTableRows();
        }
    };
    HierarchicalTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeToEntityNavigation();
        if (!this.isReadonly) {
            this.cellCounts.push(1);
            this.subscribeToFormActions();
            this.subscribeToTableActions();
        }
        this._groupByFieldName = this.groupByMetaField['metaFieldId']['systemName'];
        this.groupByCategoryName = this.groupByMetaField['compoundCategorySystemName'];
        zip_1.zip(this.getColumnData(), this.getOrderingIds())
            .takeUntil(this.destroy$)
            .subscribe(function (_a) {
            var columnData = _a[0], orderingIds = _a[1];
            _this.columnData = columnData;
            _this._orderingIds = orderingIds;
            _this.tableData = _this.getHierarchicalTableRows(_this.entity.getProperty(_this.subEntityCategoryId).value);
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    HierarchicalTableComponent.prototype.updateTableRows = function () {
        this.tableData = this.getHierarchicalTableRows(this.entity.getProperty(this.subEntityCategoryId).value);
        if (!this.tableData.length) {
            this.entity.getProperty(this.subEntityCategoryId).value = [];
        }
    };
    HierarchicalTableComponent.prototype.subscribeToTableActions = function () {
        var _this = this;
        this.afterTableActionSubject
            .takeUntil(this.destroy$)
            .subscribe(function () { return _this.updateTableRows(); });
    };
    HierarchicalTableComponent.prototype.getHierarchicalTableRows = function (subEntities) {
        var _this = this;
        var groupedSubEntities = new Map();
        subEntities.forEach(function (subEntity) {
            var subEntityGroupById = subEntity.getProperty(_this._groupByFieldName).value.getId();
            if (!groupedSubEntities.has(subEntityGroupById)) {
                groupedSubEntities.set(subEntityGroupById, new table_row_1.TableRow(subEntityGroupById, [], null));
            }
            groupedSubEntities.get(subEntityGroupById).children.push(new table_row_1.TableRow(null, null, subEntity));
        });
        if (this._orderingIds.length) {
            var orderedAndGroupedSubEntities_1 = new Map();
            this._orderingIds.forEach(function (orderId) {
                if (groupedSubEntities.has(orderId)) {
                    orderedAndGroupedSubEntities_1.set(orderId, groupedSubEntities.get(orderId));
                }
            });
            return Array.from(orderedAndGroupedSubEntities_1.values());
        }
        else {
            return Array.from(groupedSubEntities.values());
        }
    };
    HierarchicalTableComponent.prototype.getOrderingIds = function () {
        var _this = this;
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.groupByCategoryName)).pipe(operators_1.switchMap(function (metaCategoryId) {
            if (metaCategoryId.getHasCustomSorting()) {
                return _this.classifierService.loadClassifiersView(_this.groupByCategoryName);
            }
            else {
                return of_1.of([]);
            }
        }), operators_1.map(function (classifiers) { return classifiers.map(function (classifier) { return classifier.getId(); }); }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalTableComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], HierarchicalTableComponent.prototype, "groupByMetaField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalTableComponent.prototype, "cellCounts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableComponent.prototype, "mainEntityImageFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalTableComponent.prototype, "showDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalTableComponent.prototype, "editFormId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableComponent.prototype, "rootTableTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalTableComponent.prototype, "isPopupOpened", void 0);
    HierarchicalTableComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-hierarchical-table',
            styles: [require('./hierarchical-table.component.css')],
            template: require('./hierarchical-table.component.html')
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService, idm_kb_service_client_js_1.KbService, form_resolution_service_1.FormResolutionService])
    ], HierarchicalTableComponent);
    return HierarchicalTableComponent;
}(base_table_component_1.BaseTableComponent));
exports.HierarchicalTableComponent = HierarchicalTableComponent;
//# sourceMappingURL=hierarchical-table.component.js.map